import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import TabsNav from './TabsNav';
import DashboardTab from './DashboardTab';
import Equipos from './Equipos';
import EquipoMiembros from './EquipoMiembros';
import Encuestas from './Encuestas';
import Respuestas from './Respuestas';
import RespuestasLayout from './RespuestasLayout';
import DetalleIndividual from './DetalleIndividual';
import DetalleEquipo from './DetalleEquipo';
import styles from '../../styles/creatividadesSection.module.css';

const CreatividadesLayout = () => {
    return (
        <div>
            <TabsNav />
            <div className={styles.sectionWrap}>
                <Routes>
                    <Route path="/" element={<Navigate to="dashboard" replace />} />
                    <Route path="dashboard" element={<DashboardTab />} />
                    <Route path="equipos" element={<Equipos />} />
                    <Route path="equipos/:id" element={<EquipoMiembros />} />
                    <Route path="encuestas" element={<Encuestas />} />
                    <Route path="respuestas" element={<RespuestasLayout />}>
                        <Route index element={<Respuestas />} />
                        <Route path="individual/:id" element={<DetalleIndividual />} />
                        <Route path="equipo/:id" element={<DetalleEquipo />} />
                    </Route>
                </Routes>
            </div>
        </div>
    );
};

export default CreatividadesLayout;
